module.exports = __webpack_public_path__ + "static/media/mountain.70a817fe.jpg";